/**
 * Created by Ruslans on 12/14/2016.
 */

$(document).ready(function() {

    jQuery.keyboard.layouts["lv"] = {
        "name" : "lv",
        "lang" : ["lv"],
        "normal" : [
            "1 2 3 4 5 6 7 8 9 0 {bksp}",
            "q w e r t y u i o p",
            "a s d f g h j k l {accept}",
            "{alt} z x c v b n m {shift}",
            "{space} {cancel}"
        ],
        "shift" : [
            "1 2 3 4 5 6 7 8 9 0 {bksp}",
            "Q W E R T Y U I O P",
            "A S D F G H J K L {accept}",
            "{alt} Z X C V B N M {shift}",
            "{space} {cancel}"
        ],
        "alt" : [
            "1 2 3 4 5 6 7 8 9 0 {bksp}",
            "{empty} {empty} \u0113 \u0157 {empty} {empty} \u016b \u012b \u00f5 {empty}",
            "\u0101 \u0161 {empty} {empty} \u0123 {empty} {empty} \u0137 \u013c {accept}",
            "{alt} \u017e {empty} \u010d {empty} {empty} \u0146 {empty} {shift}",
            "{space} {cancel}"
        ],
        "alt-shift" : [
            "1 2 3 4 5 6 7 8 9 0 {bksp}",
            "{empty} {empty} \u0112 \u0156 {empty} {empty} \u016A \u012A \u014C {empty}",
            "\u0100 \u0160 {empty} {empty} \u0122 {empty} {empty} \u0136 \u013B {accept}",
            "{alt} \u017D {empty} \u010C {empty} {empty} \u0145 {empty} {shift}",
            "{space} {cancel}"
        ]
    };

    jQuery.keyboard.language.lv = {
        display: {
            'accept': 'Apstiprināt',
            'cancel': 'Atcelt'
        }
    };

    jQuery.keyboard.layouts["ru"] = {
        "name" : "ru",
        "lang" : ["ru"],
        "normal" : [
            "\u0451 1 2 3 4 5 6 7 8 9 0 {bksp}",
            "\u0439 \u0446 \u0443 \u043a \u0435 \u043d \u0433 \u0448 \u0449 \u0437 \u0445 \u044a",
            "\u0444 \u044b \u0432 \u0430 \u043f \u0440 \u043e \u043b \u0434 \u0436 \u044d {accept}",
            "\u044f \u0447 \u0441 \u043c \u0438 \u0442 \u044c \u0431 \u044e {shift}",
            "{space} {cancel}"
        ],
        "shift" : [
            "\u0401 1 2 3 4 5 6 7 8 9 0 {bksp}",
            "\u0419 \u0426 \u0423 \u041a \u0415 \u041d \u0413 \u0428 \u0429 \u0417 \u0425 \u042a",
            "\u0424 \u042b \u0412 \u0410 \u041f \u0420 \u041e \u041b \u0414 \u0416 \u042d {accept}",
            "\u042f \u0427 \u0421 \u041c \u0418 \u0422 \u042c \u0411 \u042e {shift}",
            "{space} {cancel}"
        ]
    };

    jQuery.keyboard.language.ru = {
        display: {
            'accept': 'Подтвердить',
            'cancel': 'Отменить'
        }
    };

    jQuery.keyboard.layouts["en"] = {
        "name" : "en",
        "lang" : ["en"],
        "normal": [
            "1 2 3 4 5 6 7 8 9 0 {bksp}",
            "q w e r t y u i o p",
            "a s d f g h j k l {accept}",
            "z x c v b n m {shift}",
            "{space} {cancel}"
        ],
        "shift": [
            "1 2 3 4 5 6 7 8 9 0 {bksp}",
            "Q W E R T Y U I O P",
            "A S D F G H J K L {accept}",
            "Z X C V B N M {shift}",
            "{space} {cancel}"
        ]
    };

    jQuery.keyboard.language.en = {
        display: {
            'accept': 'Accept',
            'cancel': 'Cancel'
        }
    };

});